'use client';

import { Button } from '@/components/ui/button';
import { zodResolver } from '@hookform/resolvers/zod';
import { FormInput } from '@veranda/shared/components/form-input';
import { Form } from '@veranda/shared/components/ui/form';
import { useElevarEvents } from '@veranda/shared/elevar';
import { subscribeToNewsletter } from '@veranda/shared/klaviyo/actions';
import {
  type NewsletterFormSchema,
  newsletterFormSchema,
} from '@veranda/shared/klaviyo/schema';
import { useAction } from 'next-safe-action/hooks';
import { useForm } from 'react-hook-form';
import { toast } from 'sonner';

export function NewsletterSignup() {
  const { trackSubscribe } = useElevarEvents();
  const form = useForm<NewsletterFormSchema>({
    resolver: zodResolver(newsletterFormSchema),
    defaultValues: {
      email: '',
    },
  });

  const { execute, isExecuting } = useAction(subscribeToNewsletter, {
    onSuccess({ data }) {
      form.reset();
      if (data?.success) {
        toast.success(data?.message);
        trackSubscribe({
          lead_type: 'email',
          user_properties: {
            customer_email: data?.email ?? '',
          },
        });
      } else {
        toast.error(data?.message);
      }
    },
    onError(error) {
      form.reset();
      toast.error(error.error.serverError);
    },
  });

  const onSubmit = form.handleSubmit((data) => {
    execute(data);
  });

  return (
    <div className="mt-12 w-full">
      <Form {...form}>
        <form onSubmit={onSubmit} className="relative">
          <span className="-rotate-[18deg] -left-2 -top-[68px] md:-left-16 md:-top-[78px] absolute font-abramo font-bold text-[48px] text-brand-burgundy md:text-[68px]">
            Sign Up!
          </span>
          <div className="flex flex-col gap-2 md:flex-row md:gap-1">
            <FormInput
              control={form.control}
              name="email"
              placeholder="Enter your email"
              containerClassName="w-full"
              inputClassName="border-4 border-brand-burgundy h-10 font-outfit text-sm md:text-base text-center md:text-left placeholder:text-center md:placeholder:text-left"
            />
            <Button
              type="submit"
              disabled={isExecuting}
              size="sm"
              className="w-full md:w-auto"
            >
              {isExecuting ? 'Submitting...' : 'Submit'}
            </Button>
          </div>
        </form>
      </Form>
    </div>
  );
}
